/**
 * Detect if the user is on a mobile device
 * @returns {boolean} true if mobile, false otherwise
 */
export const isMobileDevice = () => {
  if (typeof window === 'undefined') return false;

  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Check for mobile devices
  const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
  
  // Check if user agent matches mobile pattern
  const isMobileUA = mobileRegex.test(userAgent.toLowerCase());
  
  // Check screen size as additional verification
  const isSmallScreen = window.innerWidth <= 768;
  
  // Check if touch device
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  
  return isMobileUA || (isSmallScreen && isTouchDevice);
};

/**
 * Detect if the user is in a webview (inside a mobile app)
 * @returns {boolean} true if webview, false otherwise
 */
export const isWebView = () => {
  if (typeof window === 'undefined') return false;

  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const ua = userAgent.toLowerCase();

  // Common webview patterns
  const webViewPatterns = [
    'wv', // Android WebView
    'webview',
    'fb_iab', // Facebook in-app browser
    'fban', // Facebook app
    'fbav', // Facebook app
    'instagram', // Instagram in-app browser
    'twitter', // Twitter in-app browser
  ];

  return webViewPatterns.some(pattern => ua.includes(pattern));
};

/**
 * Check if user is on mobile browser (not in app webview)
 * @returns {boolean} true if mobile browser, false otherwise
 */
export const isMobileBrowser = () => {
  return isMobileDevice() && !isWebView();
};

/**
 * Get device type
 * @returns {string} 'mobile', 'tablet', 'desktop'
 */
export const getDeviceType = () => {
  if (typeof window === 'undefined') return 'desktop';

  const width = window.innerWidth;
  
  if (width < 768) return 'mobile';
  if (width < 1024) return 'tablet';
  return 'desktop';
};

